(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ss-multibuy"] && !Shopify.designMode) return;
  try {
    function updateMultiBuy(node){
  const form=node.closest('.product-details')?.querySelector('form[data-type="add-to-cart-form"]');
  if(!form)return;
  const input=form.querySelector('input[name="id"]');
  const variants=JSON.parse(node.querySelector('[data-ss-variants]').textContent);
  const variant=variants.find(item=>String(item.id)===input?.value);
  if(!variant)return;
  const formatter=new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'});
  node.querySelectorAll('[data-units]').forEach(row=>{
    const units=Number(row.dataset.units);
    const rate=(100-Number(row.dataset.percent))/100;
    row.querySelector('[data-each]').textContent=formatter.format(Math.round(variant.price*rate)/100);
    const subtotal=variant.price*units;
    const discount=Math.floor(subtotal*Number(row.dataset.percent)/100);
    const total=formatter.format((subtotal-discount)/100);
    row.querySelector('[data-total]').textContent=row.querySelector('[data-total]').dataset.template.replace('%s',total);
  });
}
function initMultiBuy(node){
  if(node.dataset.ready)return;
  node.dataset.ready='true';
  node.querySelectorAll('[data-total]').forEach(el=>{el.dataset.template=el.textContent.replace(/£[\d,.]+/,'%s')});
  const form=node.closest('.product-details')?.querySelector('form[data-type="add-to-cart-form"]');
  if(!form)return;
  const observer=new MutationObserver(()=>updateMultiBuy(node));
  observer.observe(form,{subtree:true,attributes:true,attributeFilter:['value']});
  form.addEventListener('change',()=>setTimeout(()=>updateMultiBuy(node),0));
  updateMultiBuy(node);
}
document.querySelectorAll('[data-ss-multibuy]').forEach(initMultiBuy);
new MutationObserver(()=>document.querySelectorAll('[data-ss-multibuy]').forEach(initMultiBuy)).observe(document.documentElement,{childList:true,subtree:true});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ss-product-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ss-product-share')) {
    customElements.define('ss-product-share', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        // Decode entities as inert textarea text, never as active page markup.
        // Normalize only WhatsApp/Pinterest text; all device and copy-link behavior stays unchanged.
        const descriptionDecoder = document.createElement('textarea');
        descriptionDecoder.innerHTML = this.dataset.linkDescription || '';
        const description = descriptionDecoder.value.replace(/\s+/g, ' ').trim();
        const descriptionCharacters = Array.from(description);
        const summary = descriptionCharacters.length > 180
          ? descriptionCharacters.slice(0, 177).join('') + '...'
          : description;
        const linkText = this.dataset.title + ' — ' + summary;
        const whatsappLink = this.querySelector('a[href^="https://wa.me/?"]');
        if (whatsappLink) {
          const whatsappUrl = new URL(whatsappLink.href);
          whatsappUrl.searchParams.set('text', linkText + ' ' + this.dataset.url);
          whatsappLink.href = whatsappUrl.toString();
        }
        const pinterestLink = this.querySelector('a[href^="https://pinterest.com/pin/create/button/?"]');
        if (pinterestLink) {
          const pinterestUrl = new URL(pinterestLink.href);
          pinterestUrl.searchParams.set('description', linkText);
          pinterestLink.href = pinterestUrl.toString();
        }
        const input = this.querySelector('.ss-share-link');
        const status = this.querySelector('.ss-share-status');
        const copyButton = this.querySelector('.ss-share-copy');
        const revealLink = () => {
          input.closest('.ss-share-link-label').hidden = false;
          input.focus();
          input.select();
        };
        this.querySelectorAll('[data-device-share]').forEach(button => {
          button.addEventListener('click', async () => {
            const platform = button.dataset.platform;
            if (!navigator.share) {
              status.textContent = this.dataset.deviceUnavailable.replace('%s', platform);
              return;
            }
            status.textContent = this.dataset.deviceHint.replace('%s', platform);
            try {
              await navigator.share({title:this.dataset.title,text:this.dataset.text,url:this.dataset.url});
            } catch (error) {
              if (error.name !== 'AbortError') {
                status.textContent = this.dataset.deviceUnavailable.replace('%s', platform);
              }
            }
          });
        });
        copyButton.addEventListener('click', async () => {
          if (!navigator.clipboard || !window.isSecureContext) {
            status.textContent = this.dataset.error;
            revealLink();
            return;
          }
          try {
            await navigator.clipboard.writeText(this.dataset.url);
            status.textContent = this.dataset.copied;
          } catch (error) {
            status.textContent = this.dataset.error;
            revealLink();
          }
        });
        input.addEventListener('click', () => input.select());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
